module.exports = __webpack_public_path__ + "static/media/app_screen_background.8e1c7785.png";